import {
  createStyles,
  makeStyles,
  Theme,
  Container,
  Box,
  Grid,
  AppBar,
  Toolbar,
  createMuiTheme,
  ThemeProvider,
  CssBaseline} from '@material-ui/core';
import { fontFaceOverrides } from '../../utils/fonts';
import FooterLinks from './FooterLinks';
import SecondaryFooter from './SecondaryFooter';
import DocumentTitle from '../DocumentTitle';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00c1bd',
    },
    secondary: {
      main: '#ff6709'
    }
  },
  typography: {
    fontFamily: [
      '"Moderat-Light"',
      'Helvetica',
      'Arial',
      'Verdana',
      'Tahoma',
      'sans-serif'
    ].join(','),

    body2: {
      color: '#fff'
    },
    h5: {
      fontFamily: 'Moderat-Black'
    }
  },
  overrides: {
    ...fontFaceOverrides
  },
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      height: 86
    },
    footer: {
      flexShrink: 0,
    },
    content: {
      flex: '1 0 auto'
    },
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    secondaryBackground: {
      backgroundColor: '#f2f1f0',
    },
    linksHeight:{
      minHeight: "50px"
    },
    '@media print': {
      linksHeight: {
        display: 'none'
      },
      secondaryBackground: {
        backgroundColor: '#fff',
        boxShadow: 'none'
      }
    }
  })
);

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FunctionComponent<LayoutProps> = (props) => {
  const classes = useStyles();
  

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className={classes.container}>
        <header>
          <Container maxWidth="lg">
            <Box display="flex" justifyContent="space-between">
              <img src="/zen-logo.svg" alt="Zen" className={classes.logo} />
              <DocumentTitle />
          </Box>
          </Container>
        </header>
        <Container maxWidth="lg" className={classes.content}>
          <Box display="flex">
            <Box flexGrow={1}>
              {props.children}
            </Box>
          </Box>
        </Container>
        <footer className={classes.footer}>
        <AppBar position="static" className={classes.secondaryBackground}>
            <Container maxWidth="md">
              <SecondaryFooter />
            </Container>
          </AppBar>
          <AppBar position="static" color="primary">
            <Container maxWidth="md">
              <Toolbar className={classes.linksHeight}>
                <Grid container>
                  <FooterLinks />
                </Grid>
              </Toolbar>
            </Container>
          </AppBar>
          
        </footer>
      </div>
    </ThemeProvider>
  )
}

export default Layout;